import { render, staticRenderFns } from "./weixin.vue?vue&type=template&id=5431cf6c&scoped=true&"
import script from "./weixin.vue?vue&type=script&lang=js&"
export * from "./weixin.vue?vue&type=script&lang=js&"
import style0 from "./weixin.vue?vue&type=style&index=0&id=5431cf6c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5431cf6c",
  null
  
)

export default component.exports